import client from '.spat/modules/client';
import app from './scripts/app';
import './scripts/riot_mixin';

// client.showSSR();

// setup flarebase
app.store.init(firebase.firestore());
app.auth.init(firebase);
app.useragent = useragent.parse(navigator.userAgent);


app.auth.on('ready', async (user) => {
  if (user) {
    await app.store.watch();
  }
  else if (!['/signin','/signup'].includes(location.pathname)) {
    spat.router.push('/signin');
  }

  client.start();

  // popup のセットアップ
  const $popup = document.createElement('div');
  spat.appTag.root.appendChild($popup);
  const popupTag = riot.mount($popup, 'module-popup')[0];
  spat.appTag.popupTag = popupTag;
  spat.popup = popupTag;

  // ウェブのときしか呼ばない TODO: ネイティブのときの対応
  // PWA 対応
  if (location.hostname !== 'localhost' && spat.config.env === 'production') {
    if ('serviceWorker' in navigator) {
      // parcel のビルドでファイル検知しようとしてエラーが出るので + で結合
      navigator.serviceWorker.register('/sw.' + 'js');
    }
  }

  // riot.update を実行する
  riot.update();
  
});


app.auth.on('signin', async (e) => {
  if (!e.user) return ;

  // TODO: email新規登録だった時の対応
  // 存在チェックしていなければユーザーを作る
  var userDoc = await app.store.collection('users').doc(e.user.uid).fetch();
  if (!userDoc.doc.exists) {
    await userDoc.ref.set({
      // 一旦screen_nameにidをいれる
      screen_name: e.user.uid,
      display_name: e.additionalUserInfo.profile.name,
      icon_url: e.additionalUserInfo.profile.picture,
      created_at: firebase.firestore.FieldValue.serverTimestamp(),
      disabled: false,
    });
  }

  spat.router.push('/');
  riot.update();

  await app.store.watch();
});

app.auth.on('signout', () => {
  app.store.unwatch();
});
